import { useState, useContext, useCallback } from "react";
import { TIERS } from "constants/pricing";
import { GenericConfigContext } from "/contexts/generic-config-context";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import classnames from "classnames";
import DownArrow from "/static/svg/arrow-down.svg";
import Button from "components/core/button/button-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import { productFeaturesTable } from "./product-features-table.scss";
import { ProductFeaturesTableSection } from "./product-features-table-section/product-features-table-section";
import { ProductIcon } from "../../../icons/product-icon";

export const ProductFeaturesTable = ({
  productName: currentProductName,
  isExpanded: isExpandedProp,
  setIsExpanded: setIsExpandedProp,
}) => {
  const productsNames = [currentProductName, ...(currentProductName === "core" ? [] : ["core"])];
  const currentProduct = productPricingConfig[currentProductName];
  const coreProduct = productPricingConfig.core;
  const { translate } = useContext(GenericConfigContext);
  const [localIsExpanded, setLocalIsExpanded] = useState(false);
  const controlledMode = setIsExpandedProp !== undefined;
  const setIsExpanded = controlledMode ? setIsExpandedProp : setLocalIsExpanded;
  const isExpanded = controlledMode ? isExpandedProp : localIsExpanded;
  const toggleFeaturesList = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [setIsExpanded, isExpanded]);
  return (
    <div className="product-features-table" role="table">
      <div className={classnames("toggle", { expanded: isExpanded })} onClick={() => toggleFeaturesList()}>
        <h2>{translate("pricingPage.completeFeaturesList")}</h2>
        <DownArrow />
      </div>
      {isExpanded && (
        <div className="grid">
          <div className="tier-header" />
          {currentProduct.tiers.map((tier) => (
            <div key={`tier-header-${tier.name}`} className="tier-header">
              <div className="tier-title">{translate(`pricingPage.tiers.${tier.name}.title`)}</div>
              <div className="tier-cta">
                {tier.name !== TIERS.ENTERPRISE ? (
                  <SignupFormComponent buttonSize="xs" />
                ) : (
                  <Button
                    className="cta-button"
                    type="button"
                    size="xs"
                    onClickCallback={() => {
                      window.location.href = "/sales/contact-us?from=pricing&source=Website%20-%20Contact%20Sales";
                    }}
                  >
                    {translate("footer.contactSales")}
                  </Button>
                )}
              </div>
            </div>
          ))}
          {productsNames.map((productName) => {
            const product = productPricingConfig[productName];
            if (product.featuresList.length === 0) {
              return null;
            }
            return (
              <>
                <div key={`product-section-header-${productName}`} className="product-section-header">
                  <div className={classnames("icon", { core: productName === "core" })}>
                    <ProductIcon product={productName} />
                  </div>
                  <h3>{translate(`pricingPage.products.${productName}.title`)}</h3>
                </div>
                {product.featuresList.map((productSection) => (
                  <ProductFeaturesTableSection
                    key={productSection.sectionName}
                    productSection={productSection}
                    productName={productName}
                  />
                ))}
              </>
            );
          })}
        </div>
      )}
      <style jsx>{productFeaturesTable}</style>
      <style jsx>{`
        .grid {
          grid-template-columns: ${`repeat(${currentProduct.tiers.length + 1},1fr)`};
        }
        .tier-cta {
          position: sticky;
          top: 72px;
          :global(.signup-button),
          :global(.cta-button) {
            background-color: transparent;
            border: 1px solid black;
            color: black;
            letter-spacing: 0.4px;
            &:hover {
              border-color: ${currentProduct.color};
              background-color: ${currentProduct.color};
              filter: none;
            }
          }
        }

        .product-section-header {
          .icon {
            background-color: ${currentProduct.color};
            &.core {
              background-color: ${coreProduct.color};
            }
          }
        }
      `}</style>
    </div>
  );
};
